var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AppConfig } from '../../config/config';
export function fetchBoost(r) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c;
        const { apiUrl, shop } = AppConfig.searchSettings.boost;
        let collectionHandle = undefined;
        let currentPage = 'collection_page';
        const searchApp = document.querySelector('#search-app');
        if (searchApp) {
            collectionHandle = searchApp.dataset.collectionHandle || '0';
            currentPage = searchApp.dataset.page || 'collection_page';
        }
        const params = new URLSearchParams({
            q: r.q || '*',
            page: String(r.page || 1),
            limit: String(r.pageSize || 24),
            shop,
            build_filter_tree: 'true',
            return_all_currency_fields: 'false',
            pg: currentPage
        });
        if (r.sort) {
            const sortMap = {
                'title:asc': 'title-ascending',
                'title:desc': 'title-descending',
                'price:asc': 'price-ascending',
                'price:desc': 'price-descending',
                'created:asc': 'created-ascending',
                'created:desc': 'created-descending',
                'best-selling': 'best-selling',
                'manual': 'manual',
                'relevance': 'relevance',
                // Legacy mapping
                title_asc: 'title-ascending',
                title_desc: 'title-descending',
                price_asc: 'price-ascending',
                price_desc: 'price-descending',
            };
            params.append('sort', sortMap[r.sort] || r.sort);
        }
        // Handle filters
        if (r.filters) {
            Object.entries(r.filters).forEach(([filterId, values]) => {
                if (values.length) {
                    // Handle special filters
                    if (filterId === 'available') {
                        params.append('product_available', values[0]);
                    }
                    else if (filterId === 'variant_available') {
                        params.append('variant_available', values[0]);
                    }
                    else if (filterId === 'tag') {
                        values.forEach(value => {
                            params.append('tag[]', value);
                        });
                    }
                    else if (filterId.startsWith('metafield.')) {
                        // Handle metafield filters (pf_* format)
                        const metafieldKey = filterId.replace('metafield.', 'pf_');
                        values.forEach(value => {
                            params.append(`${metafieldKey}[]`, value);
                        });
                    }
                    else if (filterId === 'price') {
                        // Handle price range filter
                        const [min, max] = values[0].split(',');
                        params.append('pf_p_price_min', min);
                        params.append('pf_p_price_max', max);
                    }
                    else {
                        // Standard filters
                        values.forEach(value => {
                            params.append(`${filterId}[]`, value);
                        });
                    }
                }
            });
        }
        // Handle collection search
        if (collectionHandle) {
            params.append('collection_scope', collectionHandle);
        }
        // Add AI features
        if (r.fuzzy) {
            params.append('fuzzy', 'true');
        }
        if (r.reduce_min_match) {
            params.append('reduce_min_match', 'true');
        }
        // Add merchandising parameters
        if (r.merchandising) {
            if ((_a = r.merchandising.boostProducts) === null || _a === void 0 ? void 0 : _a.length) {
                params.append('boost_products', r.merchandising.boostProducts.join(','));
            }
            if ((_b = r.merchandising.hideProducts) === null || _b === void 0 ? void 0 : _b.length) {
                params.append('hide_products', r.merchandising.hideProducts.join(','));
            }
            if ((_c = r.merchandising.pinProducts) === null || _c === void 0 ? void 0 : _c.length) {
                r.merchandising.pinProducts.forEach((pin, index) => {
                    params.append(`pin_products[${index}][id]`, pin.productId);
                    params.append(`pin_products[${index}][position]`, String(pin.position));
                });
            }
        }
        const url = `${apiUrl}${currentPage === 'collection_page' ? '/filter' : '/search'}?${params.toString()}`;
        const response = yield fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip',
            },
        });
        if (!response.ok) {
            throw new Error(`Boost API error: ${response.statusText}`);
        }
        return response.json();
    });
}
export function fetchBoostSuggestions(query_1) {
    return __awaiter(this, arguments, void 0, function* (query, limit = 10) {
        const { apiUrl, shop } = AppConfig.searchSettings.boost;
        const params = new URLSearchParams({
            q: query,
            shop,
            limit: String(limit),
            product_limit: String(Math.floor(limit * 0.7)), // 70% products
            page_limit: String(Math.floor(limit * 0.3)) // 30% pages
        });
        const url = `${apiUrl}/search/suggest?${params.toString()}`;
        const response = yield fetch(url, {
            headers: {
                'Accept-Encoding': 'gzip',
            },
        });
        if (!response.ok) {
            throw new Error(`Boost Suggest API error: ${response.statusText}`);
        }
        return response.json();
    });
}
